<template>
  <v-content>
    <v-container
      class="ma-0"
      fluid
    >
      <!-- like detail -->
      <template
        v-if="!isProfile"
      >
        <!-- Passion shot's -->
        <blockContent
          class="mt-4 mx-8"
          sytle="position:relative"
        >
          <div
            class="reaction"
          >
            <div
              class="popup"
              :class="isShowReaction ? 'd-block' : 'd-none'"
            >
              <img
                :src="profile.photoUrl"
              >
              <div>
                Thank you❣️
              </div>
            </div>
          </div>
          <div
            style="display: flex; width: 100%; overflow-x: scroll;"
          >
            <v-img
              v-for="photoUrl in post.photoUrls"
              :key="photoUrl"
              :src="photoUrl"
              max-width="300"
              max-height="300"
              style="border-radius:16px;margin-right:1px;"
            ></v-img>
          </div>
        </blockContent>
        <!-- Profile -->
        <blockContent
          class="mx-8"
        >
          <div
            class="passion-detail"
          >
            <img
              class="place-icon"
              :src="placeIcon"
            />
            <div
              class="place-text"
              v-html="profile.place"
            ></div>
            <svg
              class="heart-icon"
              @click="doLike"
              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path v-if="isLike" d="M13.3497 20.3074C12.5897 20.9974 11.4197 20.9974 10.6597 20.2974L10.5497 20.1974C5.29966 15.4474 1.86966 12.3374 1.99966 8.45741C2.05966 6.75741 2.92966 5.12741 4.33966 4.16741C6.97966 2.36741 10.2397 3.20741 11.9997 5.26741C13.7597 3.20741 17.0197 2.35741 19.6597 4.16741C21.0697 5.12741 21.9397 6.75741 21.9997 8.45741C22.1397 12.3374 18.6997 15.4474 13.4497 20.2174L13.3497 20.3074Z" fill="#FF5500" />
              <path v-else fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 5.26741C13.7602 3.20741 17.0202 2.36741 19.6602 4.16741C21.0602 5.12741 21.9402 6.74741 22.0002 8.44741C22.1302 12.3274 18.7002 15.4374 13.4502 20.1974L13.3402 20.2974C12.5802 20.9974 11.4102 20.9974 10.6502 20.3074L10.5502 20.2174L10.4898 20.1625C5.27384 15.4235 1.86075 12.3225 2.00021 8.45741C2.06021 6.74741 2.94021 5.12741 4.34021 4.16741C6.98021 2.35741 10.2402 3.20741 12.0002 5.26741ZM12.0002 18.8274L12.1002 18.7274C16.8602 14.4174 20.0002 11.5674 20.0002 8.67741C20.0002 6.67741 18.5002 5.17741 16.5002 5.17741C14.9602 5.17741 13.4602 6.16741 12.9402 7.53741H11.0702C10.5402 6.16741 9.04021 5.17741 7.50021 5.17741C5.50021 5.17741 4.00021 6.67741 4.00021 8.67741C4.00021 11.5674 7.14021 14.4174 11.9002 18.7274L12.0002 18.8274Z" fill="#929191" />
            </svg>
            <svg
              class="bookmark-icon"
              @click="doBookmark"
              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            >
              <path v-if="isBookmark" d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z" fill="#FF5500"/>
              <path v-else fill-rule="evenodd" clip-rule="evenodd" d="M7 3H17C18.1 3 19 3.9 19 5V21L12 18L5 21L5.01 5C5.01 3.9 5.9 3 7 3ZM12 15.82L17 18V5H7V18L12 15.82Z" fill="#929191"/>
            </svg>
            <img
              class="like-icon"
              :src="likeIcon"
            />
            <div
              class="like-text"
              v-text="post.likeName"
            ></div>
            <img
              class="chat-icon"
              :src="chatIcon"
            />
            <div
              class="chat-text"
              v-html="post.comment"
            ></div>
          </div>
        </blockContent>
        <hr />
        <blockTitle
          class="mx-8"
        >
          Who posted this shot?
        </blockTitle>
        <!-- Who posted Profile -->
        <blockContent
          class="who mx-8"
        >
          <img
            :src="profile.photoUrl"
            class="photo"
            @click="$router.push(`/profile/${post.uid}`)"
          >
          <div
            class="right"
          >
            <div
              class="name"
            >
              {{ profile.nickname }}&nbsp;&nbsp;<span class="generation" v-text="profile.generation"></span>
            </div>
            <div
              class="icon"
            >
              {{ profile.passionEmoji }}<br />
            </div>
            <div
              v-if="user.uid && user.uid == post.uid"
              class="button"
              @click="$router.push(`/post/${pid}`)"
            >Edit This Shot</div>
            <div
              v-else
              class="button"
              @click="doPaikeout"
              v-text="paikeoutButtonText"
            ></div>
          </div>
        </blockContent>
      </template>
      <!------------->
      <!-- Profile -->
      <!------------->
      <template
        v-else
      >
        <blockContent
          class="profile mx-8 mt-6 mb-0"
        >
          <div
            class="left"
          >
            <div
              class="name"
            >
              {{ profile.nickname }}&nbsp;&nbsp;<span class="generation" v-text="profile.generation"></span>
            </div>
            <div
              class="comment"
              :class="isTwoLine ? 'comment-two' : 'comment-all'"
              v-html="profile.comment"
            ></div>
            <div
              class="more"
              v-if="!(!profile.comment)"
              @click="isTwoLine = !isTwoLine;$vuetify.goTo(0, {duration: 100})"
              v-text="isTwoLine ? 'Read more' : 'Read less'"
            ></div>
          </div>
          <img
            :src="profile.photoUrl"
            class="photo"
          >
        </blockContent>
        <blockContent
          class="mx-8 my-0"
        >
          <div
            class="profile-icon"
            v-text="profile.passionEmoji"
          ></div>
        </blockContent>
        <btn
          v-if="user.uid == uid"
          class="mx-8 mt-2 btn-edit-profile"
          @click="$router.push('/myProfile')"
          text="Edit Profile"
        ></btn>
        <btn
          v-else
          class="mx-8 mt-2"
          @click="doPaikeout"
          :text="paikeoutButtonText"
        />
        <hr />
        <blockTitle
          class="mx-8"
        >
          <template
            v-if="user.uid == uid"
          ><template v-if="likes.length > 0">Edit</template><template v-else>Add</template> your passion shot</template>
          <template v-else>{{ profile.nickname }}'s passion shots</template>
        </blockTitle>
        <blockContent
          class="mx-8"
          v-if="likes.length > 0"
        >
          <div
            style="display: flex; width: 100%; overflow-x: scroll;"
          >
            <likeCard
              v-for="item in likes"
              :key="item.pid"
              :item="item"
              :forEdit="true"
              @click="$router.push(`/likeDetail/${item.pid}`)"
            ></likeCard>
            <v-card
              v-if="user.uid == uid"
              class="align-end"
              style="border-radius:8px;margin-left:2px"
              width="120"
              flat
            >
              <img
                :src="require('@/assets/images/shots/shots.svg')"
                style="width:120px"
                @click="$router.push('/post/new')"
              />
            </v-card>
          </div>
        </blockContent>
        <blockContent
          v-else
          class="mx-8 mt-8 no-shots"
        >
          <div
            class="no-shots-title"
          >
            No Passion Shots
          </div>
          <div
            class="no-shots-detail"
          >
            Let’s “Say Hello” to get to know this Paiker’s passion.
          </div>
        </blockContent>
      </template>
      <hr />
      <blockTitle
        class="mx-8"
      >
        Profile
      </blockTitle>
      <blockContent
        class="mx-8"
      >
        <div
          v-for="item in profileItemList"
          :key="item.label"
          class="profile-item"
        >
          <div class="label" v-text="item.label"></div>
          <div class="value" v-html="item.value"></div>
        </div>
      </blockContent>

      <messageBox
        ref="msgBox"
      ></messageBox>

      <notSignInDialog
        ref="notSignInDialog"
        title="Oops!"
        description="It looks like you have not been on Paike yet."
        @click="notSignInCallback"
      ></notSignInDialog>

      <bottomNavigation
        activeNav="likes"
      ></bottomNavigation>
    </v-container>
  </v-content>
</template>

<script>
import { mapActions } from 'vuex'
import service from '@/plugins/service'
import BottomNavigation from '@/components/Like/BottomNavigation'
import MessageBox from '@/components/MessageBox'
import LikeCard from '@/components/Like/LikeCard'
import blockTitle from '@/components/Like/BlockTitle'
import blockContent from '@/components/Like/BlockContent'
import notSignInDialog from '@/components/Like/NotSignInDialog'
import btn from '@/components/Like/Button'

export default {
  components: {
    BottomNavigation,
    LikeCard,
    MessageBox,
    btn,
    blockTitle,
    blockContent,
    notSignInDialog,
  },
  data: () => ({
    personIcon: require('@/assets/images/likes/person.svg'),
    placeIcon: require('@/assets/images/likes/place.svg'),
    bookmarkIcon: require('@/assets/images/likes/bookmark.svg'),
    chatIcon: require('@/assets/images/likes/chat.svg'),
    rid: '',
    isProfile: true,
    isTwoLine: true,
    uid: '',
    pid: '',
    isShowReaction: false,
    reactionTimerId: -1,
    notSignInCallback: () => {},
    likes: [],
    user: {
      uid: '',
    },
    isBookmark: false,
    bookmarkProcess: false,
    isLike: false,
    likeProcess: false,
    post: {
      uid: '',
      pid: '',
      photoUrls: [],
      comment: '',
      likeName: '',
      likeGroupCode: '',
    },
    profileItemList: [],
    profile: {
      uid: '',
      nickname: '',
      photoUrl: '',
      comment: '',
      authType: '',
      provided: [],
      generation: '',
      place: '',
    },
  }),
  computed: {
    likeIcon() {
      return service.getLikeGroupIcon(this.post.likeGroupCode)
    },
    place() {
      if (this.profile.whereLive) {
        return this.profile.whereLive.countryCode
      }
      return ''
    },
    paikeoutButtonText() {
      return this.rid ? 'Message' : 'Say Hello!'
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.init(to, from))
  },
  beforeRouteUpdate (to, from, next) {
    this.setData(to, from)
    next()
  },
  methods: {
    ...mapActions('storage', [
      'setNextRoute',
    ]),
    async init(to, from) {
      // ログイン状態を取得
      try {
        this.user = await service.authCheck()
      } catch (e) {
        //
      }
      this.setData(to, from)
    },
    async setData(route, from) {
      this.pid = route.params.pid
      this.uid = route.params.uid
      if (!this.pid && !this.uid) {
        // 引数がない時・・・Profileプレビュー
        if (!this.user.uid) {
          // ログインしていない時はログインさせる
          this.$router.replace('/signIn/profile')
          return
        }
        const isProfileComplete = await service.isProfileComplete(this.user.uid)
        if (!isProfileComplete) {
          // Profileが完成していない時はMyProfileへジャンプする
          this.$router.push('/myProfile')
          return
        }
        this.uid = this.user.uid
      }
      this.isProfile = !this.pid
      //
      this.likes.length = 0
      if (route.name == 'LikeDetail') {
        // Like詳細
        const post = await service.getPostInfo(this.user.uid, this.pid)
        const postData = post.res
        this.post.uid = postData.uid
        this.post.pid = this.pid
        postData.photos.forEach(item => {
          this.post.photoUrls.push(item.squareUrl)
        })
        this.post.like = postData.like
        this.post.likeCode = postData.likeCode
        if (postData.comment) {
          this.post.comment = postData.comment.replace(/\n/g, '<br />')
        } else {
          this.post.comment = "Let's chat about our common favorite!😊"
        }
        this.isBookmark = postData.isBookmark
        this.isLike = postData.isLike
        this.setProfile(postData.uid)
        // Postsの付随情報をserviceから取得する.
        const json = await service.getPost(this.pid, this.user.uid, from.path)
        if ( ! json.isError && json.res.length > 0) {
          const pp = json.res[0];
          this.post.likeName = pp.likeName
          this.post.likeGroupCode = pp.likeGroupCode
        }
      } else {
        this.post.uid = ''
        this.post.pid = ''
        this.post.photoUrls.length = 0
        this.post.like = ''
        this.setProfile(this.uid)
        this.post.comment = this.profile.comment.replace(/\n/g, '<br />')
        const json = await service.getUserLikes(this.uid)
        json.res.forEach(item => this.likes.push(item))
      }
      //
      const rid = await service.getRoomId(this.user.uid, this.profile.uid)
      this.rid = rid
    },
    async setProfile(uid) {
      const profileData = await service.getUserInfo(uid)
      this.profile.uid = uid
      this.profile.nickname = profileData.nickname
      this.profile.passionEmoji = profileData.passionEmoji
      if (!this.profile.passionEmoji) {
        this.profile.passionEmoji = '😊⚽️⚾️💖🍺🍙'
      }
      this.profile.photoUrl = profileData.photoUrl + '?height=300&width=300'
      this.profile.comment = profileData.aboutMe
      this.profile.generation = profileData.generation
      this.profile.place = `${profileData.region}, ${profileData.countryFlag}`

      const profileList = await service.getUserProfileList(uid)
      this.profileItemList.splice(0)
      profileList.forEach(item => {
        this.profileItemList.push(item)
      })
    },
    async doLike() {
      if (this.likeProcess) {
        return
      }
      this.likeProcess = true
      try {
        if (!this.user.uid) {
          // ログインしていない場合はログインの確認を表示する
          this.notSignInCallback = () => {
            this.$router.replace(`/signIn/likeDetail/${this.post.pid}`)
          }
          this.$refs.notSignInDialog.show()
          return
        }
        this.isLike = !this.isLike
        if (this.isLike) {
          await service.setLike(this.user.uid, this.pid)
          this.isShowReaction = true
          clearTimeout(this.reactionTimerId)
          this.reactionTimerId = setTimeout(() => {
            this.isShowReaction = false
          }, 3000)
        } else {
          await service.unsetLike(this.user.uid, this.pid)
          this.isShowReaction = false
        }
      } finally {
        this.likeProcess = false
      }
    },
    async doBookmark() {
      if (this.bookmarkProcess) {
        return
      }
      this.bookmarkProcess = true
      try {
        if (!this.user.uid) {
          // ログインしていない場合はログインの確認を表示する
          this.notSignInCallback = () => {
            this.$router.replace(`/signIn/likeDetail/${this.post.pid}`)
          }
          this.$refs.notSignInDialog.show()
          return
        }
        this.isBookmark = !this.isBookmark
        if (this.isBookmark) {
          await service.setBookmark(this.user.uid, this.pid)
        } else {
          await service.unsetBookmark(this.user.uid, this.pid)
        }
      } finally {
        this.bookmarkProcess = false
      }
    },
    doPaikeout() {
      if (!this.user.uid) {
        // ログインしていない場合はログインの確認を表示する
        this.notSignInCallback = () => {
          this.$router.push(`/paikeout/${this.profile.uid}`)
        }
        this.$refs.notSignInDialog.show()
      } else {
        this.$router.push(`/paikeout/${this.profile.uid}`)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.headline
  color #484848

.show-profile
  letter-spacing 0
  cursor pointer

hr
  display block
  border 1px solid #EAE9E9
  margin 16px 32px

div.profile-item
  div.label
    color #a4a2a2
    font-size 15px !important
    line-height 18px
    height 18px
    margin 16px 0 8px 0
  div.value
    color #0c0b0b
    min-height 40px
    font-size 17px !important
    line-height 20px
    margin 8px 0 16px 0

div.who
  position relative
  img.photo
    position absolute
    width 86px
    height 86px
    border-radius 43px
    cursor pointer
  div.right
    padding 0 0 0 102px
    div.name
      min-height 24px
      font-size 17px !important
      font-style normal
      font-weight bold
      line-height 25px
      span.generation
        font-size 16px
        color #6F6B69
        font-weight normal
    div.icon
      min-height 24px
      font-size 17px !important
      font-style normal
      font-weight bold
      line-height 25px
    div.button
      margin 8px 0 0 0
      height 30px
      color #FFFFFF
      font-size 17px !important
      height 38px
      line-height 38px
      background #FF5500
      border-radius 8px
      align-items center
      text-align center
      font-weight bold
      cursor pointer

.btn-edit-profile
  border 1px solid #C5C3C3
  border-radius 8px
  font-weight bold
  font-size 17px
  line-height 23px
  color #0C0B0B !important
  background #FFFFFF !important

div.profile
  position relative
  min-height 60px
  img.photo
    position absolute
    top 0
    right 0
    width 86px
    height 86px
    border-radius 43px
  div.left
    width calc(100% - 86px - 8px)
    div.name
      margin 0 0 8px 0
      min-height 18px
      font-size 17px !important
      font-style normal
      font-weight bold
      line-height 18px
      span.generation
        font-size 16px
        color #6F6B69
        font-weight normal
    div.comment
      font-size 14px !important
      font-style normal
      font-weight normal
      line-height 20px
      overflow hidden
      text-overflow ellipsis
    div.comment-two
      height 40px
    div.comment-all
      height auto
      min-height 40px
    div.more
      font-style normal
      font-weight normal
      font-size 14px
      font-height 20px
      color #3DB3E4
      cursor pointer

div.profile-icon
  width calc(100% - 86px)

div.passion-detail
  position relative
  min-height 100px
  padding-top 64px
  padding-left 32px
  img.place-icon
    position absolute
    top 0
    left 0
    width 24px
    height 24px
  div.place-text
    position absolute
    top 0
    left 32px
    width calc(100% - 32px - 32px)
    height 24px
    line-height 24px
    font-size 17px
    font-style normal
    font-weight normal
  svg.heart-icon
    position absolute
    top 0
    right 40px
    width 24px
    height 24px
  svg.bookmark-icon
    position absolute
    top 0
    right 0
    width 24px
    height 24px
  img.like-icon
    position absolute
    top 32px
    left 0
    width 24px
    height 24px
  div.like-text
    position absolute
    top 32px
    left 32px
    width calc(100% - 32px)
    height 24px
    line-height 24px
    font-size 17px
    font-style normal
    font-weight normal
  img.chat-icon
    position absolute
    top 64px
    left 0
    width 24px
    height 24px
  div.chat-text
    line-height 24px
    font-size 17px
    font-style normal
    font-weight normal

div.reaction
  position relative
  div.popup
    position absolute
    right 0
    top calc(300px - 72px)
    z-index 100
    border 1px solid #C5C3C3
    border-radius: 16px;
    background: #FFFFFF;
    &:before
      content: "";
      position: absolute;
      bottom: -17px;
      right 41px
      margin-left: -15px;
      border: 10px solid transparent;
      border-top: 8px solid #FFF;
      z-index: 2;
    &:after
      content: "";
      position: absolute;
      bottom: -20px;
      right 40px
      margin-left: -17px;
      border: 11px solid transparent;
      border-top: 9px solid #C5C3C3;
      z-index: 1;
    img
      position absolute
      top 16px
      left 16px
      width 44px
      height 44px
      border-radius 22px
    div
      margin 16px 16px 16px 68px
      min-height 44px
      font-style: normal;
      font-weight: normal;
      font-size: 17px;
      line-height: 23px;

div.no-shots
  align-items center
  text-align center
  font-weight normal
  div.no-shots-title
    color #0C0B0B
    font-size 17px
  div.no-shots-detail
    color #6F6B69
    font-size 14px
    letter-spacing -0.03em

</style>

